// ── Couleurs par source ───────────────────────────────────────────────────────

export const SOURCE_COLORS = {
    etab:                   '#1976d2',
    bdnb:                   '#388e3c',
    batimentGroupe:         '#f57c00',
    BdnbProp:               '#7b1fa2',
    BdnbBatimentGroupeRnc:  '#c62828',
    Dpes:                   '#00838f',
    BatimentGroupeAdresses: '#5d4037',
    Parcelles:              '#558b2f',
    BatimentGroupeAdresse:  '#0277bd',
    BatimentConstruction:   '#6a1b9a',
    BdnbProprietaires:      '#ad1457',
    BdnbRnc:                '#e65100',
};

// ── Mapping préfixe de colonne → label & couleur (pour le DataGrid) ───────────

export const SOURCE_PREFIX_MAP = {
    meta:                                       {label: 'Méta',            color: '#546e7a'},
    other:                                      {label: 'Synthèse',        color: '#00796b'},
    adresses:                                   {label: 'Adresses',        color: SOURCE_COLORS.BatimentGroupeAdresses},
    batiment_groupe:                            {label: 'Groupe',          color: SOURCE_COLORS.batimentGroupe},
    batiment_groupe_bdtopo_bat:                 {label: 'BDTOPO Bât.',     color: SOURCE_COLORS.bdnb},
    batiment_groupe_rnc:                        {label: 'Groupe RNC',      color: SOURCE_COLORS.BdnbBatimentGroupeRnc},
    batiment_groupe_synthese_propriete_usage:   {label: 'Propriétés',      color: SOURCE_COLORS.BdnbProp},
    batiment_groupe_adresse:                    {label: 'Gr. Adresse',     color: SOURCE_COLORS.BatimentGroupeAdresse},
    batiment_construction:                      {label: 'Construction',    color: SOURCE_COLORS.BatimentConstruction},
    parcelles:                                  {label: 'Parcelles',       color: SOURCE_COLORS.Parcelles},
    proprietaires:                              {label: 'Propriétaires',   color: SOURCE_COLORS.BdnbProprietaires},
    rnc:                                        {label: 'RNC',             color: SOURCE_COLORS.BdnbRnc},
    dpes:                                       {label: 'DPEs',            color: SOURCE_COLORS.Dpes},
    etab:                                       {label: 'Établissements',  color: SOURCE_COLORS.etab},
};

// ── Accesseurs de données par source ─────────────────────────────────────────

export const SOURCE_DATA_MAP = {
    etab:                   e => e.etab,
    bdnb:                   e => e.batiments,
    batimentGroupe:         e => e.batimentGroupe,
    BdnbProp:               e => e.proprietaires,
    BdnbBatimentGroupeRnc:  e => e.batimentGroupeRnc,
    BatimentGroupeAdresses: e => e.batimentGroupeAdresses,
    Parcelles:              e => e.parcelles,
    Dpes:                   e => e.dpes,
    BatimentGroupeAdresse:  e => e.batimentGroupeAdresse,
    BatimentConstruction:   e => e.batimentConstruction,
};

// ── Configuration des sources (ordre d'affichage) ─────────────────────────────

export const SOURCES_CONFIG = [
    {key: 'etab',                   label: 'Établissements',      color: SOURCE_COLORS.etab},
    {key: 'Dpes',                   label: 'DPEs',                color: SOURCE_COLORS.Dpes},
    {key: 'BdnbProp',               label: 'BDNB Propriétés',     color: SOURCE_COLORS.BdnbProp},
    {key: 'BdnbProprietaires',      label: 'BDNB Propriétaires',  color: SOURCE_COLORS.BdnbProprietaires},
    {key: 'bdnb',                   label: 'BDNB Bâtiments',      color: SOURCE_COLORS.bdnb},
    {key: 'BdnbBatimentGroupeRnc',  label: 'BDNB Groupe RNC',     color: SOURCE_COLORS.BdnbBatimentGroupeRnc},
    {key: 'BdnbRnc',                label: 'RNC',                 color: SOURCE_COLORS.BdnbRnc},
    {key: 'batimentGroupe',         label: 'BDNB Groupe',         color: SOURCE_COLORS.batimentGroupe},
    {key: 'BatimentGroupeAdresses', label: 'BDNB Adr. Groupes',  color: SOURCE_COLORS.BatimentGroupeAdresses},
    {key: 'Parcelles',              label: 'Parcelles',           color: SOURCE_COLORS.Parcelles},
    {key: 'BatimentGroupeAdresse',  label: 'BDNB Gr. Adresse',   color: SOURCE_COLORS.BatimentGroupeAdresse},
    {key: 'BatimentConstruction',   label: 'BDNB Construction',  color: SOURCE_COLORS.BatimentConstruction},
];
